import { BaseValueAccessor } from './base-value-accessor';
import { EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { FormEvent } from '../../crud/form/form-event.enum';

export abstract class BaseElement<T> extends BaseValueAccessor<T> {

  @Input() channel: Subject<FormEvent>;
  @Input() hint: string = '';
  @Input() isRequired: boolean;
  @Input() disabled: boolean = false;
  @Input() form: FormGroup;
  @Input() formControlName: string;
  @Input() formGroupClass: string;
  @Input() modelOptions: any = {};
  @Input() model: any = {};
  @Input() name: string = '';
  @Input() errorMessages: string | { [key: string]: string };
  @Input() customClass: any = {};
  @Input() customStyle: any = {};
  @Input() customFeedbackClass: any = {};
  @Input() customFeedbackStyle: any = {};
  @Input() label: string = '';
  @Input() autocomplete: string = 'off';
  @Input() icon: string;
  @Output('change') public change: EventEmitter<any> = new EventEmitter<any>();
  @Output('keyup') public keyupEvent: EventEmitter<any> = new EventEmitter<any>();
  @Input() id: string = Math.random().toString(36).substr(2, 10);

  constructor() {
    super();
  }
}
